import React from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

const NotFound = () => (
  <Container>
    <Image src={require('../../images/404.svg')} />
    <Typography variant="title">
Page Not Found
    </Typography>
  </Container>
);

export default NotFound;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > * + * {
    margin-top: 20px !important;
  }
`;

const Image = styled.img`
  width: 400px;
`;



// WEBPACK FOOTER //
// ./src/pages/NotFound/NotFound.js